/* DEMO MODE — Mock alle /api/* calls met realistische dummy data.
 *
 * Activatie: zet `localStorage.setItem('voorraad-kh-demo', '1')` (of via dev-console).
 * De main.tsx importeert dit bestand en installeert de interceptor als de flag aanstaat.
 *
 * NB: dit is alleen voor showcasing / dev-demo zonder backend. In productie wordt
 * deze code niet uitgevoerd zolang de flag niet wordt gezet.
 */

const ORG_BILAL = {
  id: 1, naam: 'Bilal Chicken Centre B.V.', kvk: '34246745',
  contactpersoon: 'Saskia Caki', email: 'saskia@bilal.nl', bederfelijke_waar: 'Ja',
  fin_pct_voorraad: 80, fin_pct_emballage: 70, fin_pct_verpakking: 70, fin_pct_overig: 60,
  min_houdbaarheidsdagen: 180, actief: true, aanmaakdatum: '2026-05-28',
}
const ORG_BAKKER = {
  id: 2, naam: 'Bakker Demo B.V.', kvk: '12345678',
  contactpersoon: 'Jan Bakker', email: 'jan@bakker.nl', bederfelijke_waar: 'Ja',
  fin_pct_voorraad: 75, fin_pct_emballage: 60, fin_pct_verpakking: 60, fin_pct_overig: 50,
  min_houdbaarheidsdagen: 90, actief: true, aanmaakdatum: '2026-06-15',
}

const DASHBOARD_1 = {
  organisation_id: 1, organisation_naam: 'Bilal Chicken Centre B.V.',
  bederfelijke_waar_actief: true,
  kpi: { waarderingsom: 814497.97, deductiesom: 16230.82, waarderingsom_financierbaar: 798267.15 },
  banksheet: {
    liggend: 692762.29, zeilend: 118983.00, totaal: 811745.29,
    emballage: 169412.05, verpakking: 66034.61, overig: 0,
    crediteuren_open: 16230.82, norf: 0, incourant: 54036.40,
    vrije_voorraad: 741478.07, financierbaar: 744432.12,
    fin_pct_voorraad: 80, fin_pct_emballage: 70, fin_pct_verpakking: 70, fin_pct_overig: 60,
    min_houdbaarheidsdagen: 180,
  },
  voorraadsamenstelling: { aantal_partijen: 178, totaal_eenheden: 21805 },
  tht_buckets: [
    { klasse: 'Verlopen', partijen: 0, waarde: 0, pct: 0 },
    { klasse: 'A - Tot 6 maanden', partijen: 8, waarde: 54036.40, pct: 6.7 },
    { klasse: 'B - 6 tot 12 maanden', partijen: 28, waarde: 196380.80, pct: 24.2 },
    { klasse: 'C - 12 tot 18 maanden', partijen: 89, waarde: 527422.10, pct: 65.0 },
    { klasse: 'D - Meer dan 18 maanden', partijen: 53, waarde: 33906.00, pct: 4.2 },
    { klasse: 'Geen THT', partijen: 0, waarde: 0, pct: 0 },
  ],
  open_facturen: [
    { factuurnr: '905565',    bedrag: 7417.50 },
    { factuurnr: '901816226', bedrag: 3180.00 },
    { factuurnr: '265001263', bedrag: 1440.00 },
    { factuurnr: 'PSI018734', bedrag: 4193.32 },
  ],
}

const VOORRAAD_1 = [
  { id: 1, organisation_id: 1, partijnummer: '260508004', productomschrijving: 'ENTRECOTE STRIPLOIN',
    aantal: 420, eenheid: 'Krat', waarderingsprijs_per_eenheid: 47.50, totale_waarde: 19950,
    inslagdatum: '2026-04-12', tht_datum: '2027-09-14', resterende_dagen: 474,
    opslaglocatie: 'Sumer Food', voorraadstatus: 'Liggend', orderstatus: 'Onverkocht',
    crediteur: 'Sumer Food', crediteurnummer: '201585', inkoopfactuurnr: 'PSI018733' },
  { id: 2, organisation_id: 1, partijnummer: '260511001', productomschrijving: 'KIPDONER',
    aantal: 400, eenheid: 'Krat', waarderingsprijs_per_eenheid: 77.95, totale_waarde: 31180,
    inslagdatum: '2026-05-08', tht_datum: '2027-12-15', resterende_dagen: 566,
    opslaglocatie: 'Sumer Food', voorraadstatus: 'Liggend', orderstatus: 'Onverkocht',
    crediteur: 'Sumer Food', crediteurnummer: '201585', inkoopfactuurnr: '256764' },
  { id: 3, organisation_id: 1, partijnummer: '260512007', productomschrijving: 'SHOARMA MIX',
    aantal: 380, eenheid: 'Krat', waarderingsprijs_per_eenheid: 71.50, totale_waarde: 27170,
    inslagdatum: '2026-05-08', tht_datum: '2027-10-10', resterende_dagen: 500,
    opslaglocatie: 'Sumer Food', voorraadstatus: 'Liggend', orderstatus: 'Onverkocht',
    crediteur: 'Sumer Food', crediteurnummer: '201585', inkoopfactuurnr: '256351' },
  { id: 4, organisation_id: 1, partijnummer: '901789251', productomschrijving: 'KIPDIJ FILET 200G',
    aantal: 800, eenheid: 'Doos', waarderingsprijs_per_eenheid: 18.50, totale_waarde: 14800,
    inslagdatum: '2026-03-20', tht_datum: '2026-09-20', resterende_dagen: 91,
    opslaglocatie: 'Bilal Chicken Centre B.V.', voorraadstatus: 'Liggend', orderstatus: 'Voorverkocht',
    crediteur: 'Halal Quality Meats', crediteurnummer: '100056', inkoopfactuurnr: '901789251' },
  { id: 5, organisation_id: 1, partijnummer: '905565-A', productomschrijving: 'KIPHAANTJES',
    aantal: 150, eenheid: 'Krat', waarderingsprijs_per_eenheid: 49.45, totale_waarde: 7417.50,
    inslagdatum: '2026-05-25', tht_datum: '2026-08-05', resterende_dagen: 45,
    opslaglocatie: 'Bilal Chicken Centre B.V.', voorraadstatus: 'Liggend', orderstatus: 'Onverkocht',
    crediteur: 'Seara Meats B.V.', crediteurnummer: '200012', inkoopfactuurnr: '905565' },
  { id: 6, organisation_id: 1, partijnummer: 'ZEIL-2026-04', productomschrijving: 'KIPFILET DIEPVRIES 1KG',
    aantal: 2200, eenheid: 'KG', waarderingsprijs_per_eenheid: 54.08, totale_waarde: 118983,
    inslagdatum: '2026-06-15', tht_datum: '2027-06-01', resterende_dagen: 365,
    opslaglocatie: 'Onderweg (BR→NL)', voorraadstatus: 'Zeilend', orderstatus: 'Voorverkocht',
    crediteur: 'Brasilian Poultry Ltd', crediteurnummer: '300041', inkoopfactuurnr: 'BR-2026-0418' },
]

const FACTUREN_1 = [
  { inkoopfactuurnr: '905565', crediteur: 'Seara Meats B.V.', crediteurnummer: '200012',
    voorraad: 7417.50, emballage: 0, verpakkingen: 0, overig: 0, waarderingsom: 7417.50,
    betaalstatus: 'Open' as const, deelbetaling_bedrag: 0,
    factuurdatum: '2026-06-01', vervaldatum: '2026-07-01', betaaldatum: null,
    deductie: 7417.50, deductiereden: 'Openstaande factuur', waarderingsom_financierbaar: 0 },
  { inkoopfactuurnr: '901816226', crediteur: 'Halal Quality Meats', crediteurnummer: '100056',
    voorraad: 3180, emballage: 0, verpakkingen: 0, overig: 0, waarderingsom: 3180,
    betaalstatus: 'Open' as const, deelbetaling_bedrag: 0,
    factuurdatum: '2026-06-10', vervaldatum: '2026-07-10', betaaldatum: null,
    deductie: 3180, deductiereden: 'Openstaande factuur', waarderingsom_financierbaar: 0 },
  { inkoopfactuurnr: '256764', crediteur: 'Sumer Food', crediteurnummer: '201585',
    voorraad: 31180, emballage: 0, verpakkingen: 0, overig: 0, waarderingsom: 31180,
    betaalstatus: 'Deelbetaling' as const, deelbetaling_bedrag: 15000,
    factuurdatum: '2026-05-20', vervaldatum: '2026-06-20', betaaldatum: '2026-06-18',
    deductie: 16180, deductiereden: 'Restant na deelbetaling', waarderingsom_financierbaar: 15000 },
  { inkoopfactuurnr: 'PSI018733', crediteur: 'Sumer Food', crediteurnummer: '201585',
    voorraad: 19950, emballage: 0, verpakkingen: 0, overig: 0, waarderingsom: 19950,
    betaalstatus: 'Betaald' as const, deelbetaling_bedrag: 0,
    factuurdatum: '2026-04-15', vervaldatum: '2026-05-15', betaaldatum: '2026-05-10',
    deductie: 0, deductiereden: '', waarderingsom_financierbaar: 19950 },
  { inkoopfactuurnr: '256351', crediteur: 'Sumer Food', crediteurnummer: '201585',
    voorraad: 27170, emballage: 0, verpakkingen: 0, overig: 0, waarderingsom: 27170,
    betaalstatus: 'Betaald' as const, deelbetaling_bedrag: 0,
    factuurdatum: '2026-05-12', vervaldatum: '2026-06-12', betaaldatum: '2026-06-11',
    deductie: 0, deductiereden: '', waarderingsom_financierbaar: 27170 },
]

const EMBALLAGE_1 = [
  { id: 1, organisation_id: 1, type_emballage: 'Krat mix (99001)', artikelnummer: null,
    aantal: 5372, waarde_per_stuk: 4.69, totale_waarde: 25194.68,
    opslaglocatie: 'Uitstaand bij debiteuren', opmerkingen: 'Diverse klanten' },
  { id: 2, organisation_id: 1, type_emballage: 'Europallet (99002)', artikelnummer: null,
    aantal: 420, waarde_per_stuk: 20, totale_waarde: 8400,
    opslaglocatie: 'Bilal Chicken Centre B.V.', opmerkingen: 'Op locatie' },
  { id: 3, organisation_id: 1, type_emballage: 'H1 pallet (99029)', artikelnummer: null,
    aantal: 149, waarde_per_stuk: 75, totale_waarde: 11175,
    opslaglocatie: 'Uitstaand bij debiteuren', opmerkingen: 'Diverse klanten' },
  { id: 4, organisation_id: 1, type_emballage: 'Krat geel/rood (99031)', artikelnummer: null,
    aantal: 2135, waarde_per_stuk: 5, totale_waarde: 10675,
    opslaglocatie: 'Uitstaand bij debiteuren', opmerkingen: 'Diverse klanten' },
]

const VERPAKKING_1 = [
  { id: 1, organisation_id: 1, artikel: 'Bilal deksel filet', artikelnummer: 'De4P9-0158-010',
    aantal: 20000, eenheid: 'Stuk', inkoopprijs_per_eenheid: 0.49, totale_waarde: 9800,
    minimum_voorraad: 5000, status: 'OK', crediteur: 'Packtrader', opslaglocatie: 'Van de Velde' },
  { id: 2, organisation_id: 1, artikel: 'Doos kip-trays', artikelnummer: 'DT-200-040',
    aantal: 3500, eenheid: 'Stuk', inkoopprijs_per_eenheid: 0.85, totale_waarde: 2975,
    minimum_voorraad: 1000, status: 'OK', crediteur: 'Packtrader', opslaglocatie: 'Van de Velde' },
  { id: 3, organisation_id: 1, artikel: 'Etiket halal blauw', artikelnummer: 'ET-HL-BL',
    aantal: 12000, eenheid: 'Stuk', inkoopprijs_per_eenheid: 0.03, totale_waarde: 360,
    minimum_voorraad: 2000, status: 'OK', crediteur: 'Packtrader', opslaglocatie: 'Van de Velde' },
]

const GEBRUIKERS = [
  { id: 1, gebruikersnaam: 'saskia', volledige_naam: 'Saskia Caki', email: 'saskia@bilal.nl',
    rol: 'admin' as const, organisation_id: 1, organisation_naam: 'Bilal Chicken Centre B.V.',
    actief: true, laatste_login: '2026-06-21T08:30:00', created_at: '2026-05-28T18:46:00' },
  { id: 2, gebruikersnaam: 'jan.bakker', volledige_naam: 'Jan Bakker', email: 'jan@bakker.nl',
    rol: 'admin' as const, organisation_id: 2, organisation_naam: 'Bakker Demo B.V.',
    actief: true, laatste_login: null, created_at: '2026-06-15T10:00:00' },
]

const LIJSTEN_1: Record<string, string[]> = {
  Crediteur: ['Sumer Food', 'Halal Quality Meats', 'Seara Meats B.V.', 'Packtrader', 'Brasilian Poultry Ltd'],
  Opslaglocatie: ['Bilal Chicken Centre B.V.', 'Sumer Food', 'Van de Velde', 'Uitstaand bij debiteuren'],
  Eenheid: ['KG', 'Doos', 'Krat', 'Stuk', 'Pallet'],
  Voorraadstatus: ['Liggend', 'Zeilend'],
  Orderstatus: ['Onverkocht', 'Voorverkocht'],
  Overig_categorie: ['Gereedschappen', 'Installaties', 'Overig actief'],
}

const MUTATIES = [
  { id: 1, tijdstip: '2026-06-21T14:30:12', gebruiker: 'saskia',
    pagina: 'Invoer voorraad', actie: 'Toegevoegd', entiteit: 'Voorraadpartij',
    identificatie: '260508004', detail: 'ENTRECOTE STRIPLOIN · 420 Krat · € 19950', organisation_id: 1 },
  { id: 2, tijdstip: '2026-06-21T13:55:01', gebruiker: 'kh.admin',
    pagina: 'Financierbaar', actie: 'Gewijzigd', entiteit: 'Betaling',
    identificatie: '256764', detail: 'status Open→Deelbetaling, deelbedrag=15000', organisation_id: 1 },
  { id: 3, tijdstip: '2026-06-21T11:22:30', gebruiker: 'kh.admin',
    pagina: 'Beheer/Gebruikers', actie: 'Toegevoegd', entiteit: 'Gebruiker',
    identificatie: 'saskia', detail: 'Saskia Caki · rol=admin', organisation_id: 1 },
  { id: 4, tijdstip: '2026-06-20T16:01:45', gebruiker: 'kh.admin',
    pagina: 'Beheer/Bedrijven', actie: 'Toegevoegd', entiteit: 'Bedrijf',
    identificatie: 'Bilal Chicken Centre B.V.', detail: 'KvK=34246745, contact=Saskia Caki', organisation_id: null },
  { id: 5, tijdstip: '2026-06-20T09:00:00', gebruiker: 'kh.admin',
    pagina: 'Beheer/Lijsten', actie: 'Toegevoegd', entiteit: 'Lijst',
    identificatie: 'Crediteur: Sumer Food', detail: '', organisation_id: 1 },
]

const FALLBACK_DASHBOARD_LEEG = (orgId: number, naam: string) => ({
  organisation_id: orgId, organisation_naam: naam, bederfelijke_waar_actief: true,
  kpi: { waarderingsom: 0, deductiesom: 0, waarderingsom_financierbaar: 0 },
  banksheet: { liggend: 0, zeilend: 0, totaal: 0, emballage: 0, verpakking: 0, overig: 0,
    crediteuren_open: 0, norf: 0, incourant: 0, vrije_voorraad: 0, financierbaar: 0,
    fin_pct_voorraad: 75, fin_pct_emballage: 60, fin_pct_verpakking: 60, fin_pct_overig: 50,
    min_houdbaarheidsdagen: 90 },
  voorraadsamenstelling: { aantal_partijen: 0, totaal_eenheden: 0 },
  tht_buckets: [], open_facturen: [],
})


function installDemoMocks() {
  if (typeof window === 'undefined') return
  const w = window as unknown as { __demoMocksInstalled?: boolean; fetch: typeof fetch }
  if (w.__demoMocksInstalled) return
  w.__demoMocksInstalled = true

  const orig = window.fetch.bind(window)
  const ok = (body: unknown) => new Response(JSON.stringify(body), {
    status: 200, headers: { 'Content-Type': 'application/json' },
  })
  const noContent = () => new Response(null, { status: 204 })

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : (input as Request).url ?? String(input)
    const path = url.startsWith('http') ? new URL(url).pathname : url
    const method = (init?.method ?? 'GET').toUpperCase()

    // ── Auth ─────────────────────────────────────────────────────
    if (path === '/api/auth/login') {
      return ok({
        access_token: 'demo-token',
        token_type: 'bearer',
        user: { id: -1, gebruikersnaam: 'kh.admin', volledige_naam: 'KapitaalHuys Beheerder',
                email: 'c.habraken@kredietverzekeringadvies.nl',
                rol: 'superadmin', organisation_id: null, organisation_naam: null, actief: true },
      })
    }
    if (path === '/api/auth/me') {
      return ok({ id: -1, gebruikersnaam: 'kh.admin', rol: 'superadmin', actief: true })
    }

    // ── Organisations ────────────────────────────────────────────
    if (path === '/api/organisations') return ok([ORG_BILAL, ORG_BAKKER])
    if (path.match(/^\/api\/organisations\/1$/)) return ok(ORG_BILAL)
    if (path.match(/^\/api\/organisations\/2$/)) return ok(ORG_BAKKER)

    // ── Dashboard ────────────────────────────────────────────────
    if (path === '/api/dashboard/1') return ok(DASHBOARD_1)
    if (path === '/api/dashboard/2') return ok(FALLBACK_DASHBOARD_LEEG(2, 'Bakker Demo B.V.'))

    // ── Voorraad ─────────────────────────────────────────────────
    if (path.startsWith('/api/voorraad/1')) return ok(VOORRAAD_1)
    if (path.startsWith('/api/voorraad/2')) return ok([])

    // ── Materiaal ────────────────────────────────────────────────
    if (path.startsWith('/api/materiaal/emballage/1')) return ok(EMBALLAGE_1)
    if (path.startsWith('/api/materiaal/verpakking/1')) return ok(VERPAKKING_1)
    if (path.startsWith('/api/materiaal/overig/1'))     return ok([])
    if (path.match(/\/api\/materiaal\/(emballage|verpakking|overig)\/2/)) return ok([])

    // ── Financierbaar ────────────────────────────────────────────
    if (path === '/api/financierbaar/1') {
      return ok({
        organisation_id: 1, organisation_naam: 'Bilal Chicken Centre B.V.',
        waarderingsom_totaal: 88897.50, deductiesom_totaal: 26777.50,
        waarderingsom_financierbaar_totaal: 62120,
        facturen: FACTUREN_1,
      })
    }
    if (path === '/api/financierbaar/2') {
      return ok({ organisation_id: 2, organisation_naam: 'Bakker Demo B.V.',
                  waarderingsom_totaal: 0, deductiesom_totaal: 0,
                  waarderingsom_financierbaar_totaal: 0, facturen: [] })
    }
    if (path.match(/^\/api\/financierbaar\/\d+\/betalingen$/) && method === 'PUT') {
      return ok({ gewijzigd: 1, nieuw: 0 })
    }

    // ── Gebruikers ───────────────────────────────────────────────
    if (path === '/api/gebruikers') return ok(GEBRUIKERS)
    if (path.match(/^\/api\/gebruikers\/\d+$/) && method === 'PUT') return ok(GEBRUIKERS[0])
    if (path.match(/^\/api\/gebruikers\/\d+$/) && method === 'DELETE') return noContent()

    // ── Lijsten ──────────────────────────────────────────────────
    if (path === '/api/lijsten/1') return ok(LIJSTEN_1)
    if (path === '/api/lijsten/2') return ok({})
    if (path.match(/^\/api\/lijsten\/1\/(\w+)$/)) {
      const cat = path.split('/').pop() as string
      return ok((LIJSTEN_1[cat] ?? []).map((w, i) => ({
        id: i + 1, categorie: cat, waarde: w, actief: true,
      })))
    }
    if (path.match(/^\/api\/lijsten\/\d+/) && (method === 'POST' || method === 'DELETE')) {
      return method === 'POST' ? ok({ id: 99, categorie: 'Crediteur', waarde: 'Demo', actief: true }) : noContent()
    }

    // ── Mutatielog ───────────────────────────────────────────────
    if (path === '/api/mutatielog') return ok(MUTATIES)

    // ── Bedrijven mutaties ───────────────────────────────────────
    if (path === '/api/bedrijven' && method === 'POST') return ok(ORG_BILAL)
    if (path.match(/^\/api\/bedrijven\/\d+$/) && method === 'PUT') return ok(ORG_BILAL)
    if (path.match(/^\/api\/bedrijven\/\d+$/) && method === 'DELETE') return noContent()

    // Fallback naar echte fetch (zou via vite proxy → 8000 gaan)
    return orig(input, init)
  }
  console.info('🎨 voorraad-kh DEMO MODE actief — alle /api/* calls worden gemockt.')
}

// Auto-install bij module-laad als de flag aanstaat
if (typeof window !== 'undefined' && localStorage.getItem('voorraad-kh-demo') === '1') {
  installDemoMocks()
}

export { installDemoMocks }
